<app-page padding="0">
    <p>enti page</p>
</app-page>
